// extracted by mini-css-extract-plugin
export default {"comments":"Comments_comments__pMSCd","list":"Comments_list__6guNG"};